import React from 'react';
import { Input } from '@/components/ui/input';

interface SubdomainInputProps {
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    placeholder?: string;
    disabled?: boolean;
    error?: string;
}

const SITE_HOSTNAME = window.location.host.replace(/^(www\.)?/, '');

const SubdomainInput: React.FC<SubdomainInputProps> = ({
    name,
    value,
    onChange,
    onBlur,
    placeholder = '',
    disabled = false,
    error,    
}) => {
    return (
        <div className={`flex items-center gap-2 flex-row`}>
             <span className="text-gray-500 text-sm whitespace-nowrap">
                {SITE_HOSTNAME}.
            </span>
            <Input
                id={name}
                name={name}
                type="text"
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                placeholder={placeholder}
                disabled={disabled}
                className="w-40"                
            />
           
            {error && <div className="text-red-500 text-xs ml-2">{error}</div>}
        </div>
    );
};

export default SubdomainInput;